import { UserToken, UserWithHistory } from './user'
import { Room, RoomInfo, RoomMetrics } from './room'
import { UUID } from './index'

export enum MessageType {
  SEND = 'SEND',
  SUBSCRIBE = 'SUBSCRIBE',
  UNSUBSCRIBE = 'UNSUBSCRIBE'
}

export interface WsMessageHeaders {
  token: UserToken
  timestamp: number
}

export interface WsMessage<T> {
  kind: MessageType
  channel: string
  headers?: WsMessageHeaders
  payload?: T
}


export interface WsRoom {
  room: Room
}

export interface WsRoomCreated {
  room: Room
}

export interface WsInterpreterUpdate {
  room_metrics: RoomMetrics
  rooms: Room[]
  users: UserWithHistory[]
}

export interface WsUserUpdate {
  room_metrics: RoomMetrics
}

export interface WsJoin {
  invitation: RoomInfo
}

export interface WsUserSession{
  id: UUID
}

/**
 * Subtitle message sent by interpreter's speech recognition
 */
export interface WsSubtitle {
  type: 'WsSubtitle'
  /** UUID of the interpreter sending the subtitle */
  interpreter_id: string
  /** Interpreter's display name */
  interpreter_name: string
  /** The transcribed text */
  text: string
  /** Whether this is a final transcription */
  is_final: boolean
  /** Confidence score (0.0 - 1.0) */
  confidence?: number
  /** Language code (e.g., 'el-GR') */
  language: string
  /** Sequence number for ordering (per session) */
  sequence: number
  /** Random id of the sender's transcription session; changes when the
   *  interpreter (re)joins, so receivers can detect a sequence reset */
  session_id: string
  /** Timestamp when the subtitle was generated */
  timestamp: number
}
